// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"96a9303f","202":"5ab8bc9f","234":"7eb605db","249":"1702cebd","358":"2f576452","361":"d91c8559","377":"c6621667","455":"6fe3aed4","488":"406ccb44","579":"0f4e08de","870":"4e91d09b","922":"00b2aec6","967":"71202aa4","977":"b937554b"}[chunkId] + ".chunk.js";
};